import { z } from "zod";
import { gql } from "graphql-request";
import { Image, ImageFragment } from "./image";

export const SocialLink = z.object({
  linkUrl: z.string().nullable(),
  linkLocale: z.string().nullable(),
  linkPage: z.string().nullable(),
  socialLinkImage: Image.nullable(),
  socialLinkImageEn: Image.nullable(),
});

export type SocialLink = z.infer<typeof SocialLink>;

export const SocialLinkFragment = gql`
  fragment SocialLinkFragment on SocialLink {
    linkUrl
    linkLocale
    linkPage

    socialLinkImage {
      ...ImageFragment
    }
    socialLinkImageEn: socialLinkImage(locale: "en") {
      ...ImageFragment
    }
  }

  ${ImageFragment}
`;
